import { useQuery } from '@tanstack/react-query';
import api from './authService';

// API functions for admin transactions
export const adminTransactionApi = {
  // Get all transactions for admin view
  getAdminTransactions: async (params = {}) => {
    const response = await api.get('/admin/transactions', { params });
    return response.data;
  },

  // Get all payments for admin view
  getAdminPayments: async (params = {}) => {
    const response = await api.get('/admin/payments', { params });
    return response.data;
  },

  // Get all refunds for admin view
  getAdminRefunds: async (params = {}) => {
    const response = await api.get('/admin/refunds', { params });
    return response.data;
  },

  getPaymentStatistics: async (params = {}) => {
    const response = await api.get('/admin/payments/statistics', { params });
    return response.data;
  },

  getTransactionStatistics: async (params = {}) => {
    const response = await api.get('/admin/transactions/statistics', { params });
    return response.data;
  },
};

// React Query Hooks

// Get all admin transactions
export const useAdminTransactions = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminTransactions', params],
    queryFn: () => adminTransactionApi.getAdminTransactions(params),
    staleTime: 5 * 60 * 1000, // Data considered fresh for 5 minutes
    retry: false, // Don't retry if endpoint doesn't exist
    ...options
  });
};

// Get all admin payments
export const useAdminPayments = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminPayments', params],
    queryFn: () => adminTransactionApi.getAdminPayments(params),
    staleTime: 5 * 60 * 1000,
    ...options
  });
};

// Get all admin refunds
export const useAdminRefunds = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminRefunds', params],
    queryFn: () => adminTransactionApi.getAdminRefunds(params),
    staleTime: 5 * 60 * 1000,
    retry: false, // Don't retry if endpoint doesn't exist
    ...options
  });
};

export const useAdminPaymentStatistics = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminPaymentStatistics', params],
    queryFn: () => adminTransactionApi.getPaymentStatistics(params),
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useAdminTransactionStatistics = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['adminTransactionStatistics', params],
    queryFn: () => adminTransactionApi.getTransactionStatistics(params),
    staleTime: 60 * 1000,
    ...options,
  });
};

